const $body = document.querySelector("body");
const $html = document.querySelector("html");

// core app
const coreApp = (function () {
	return {
		init: function () {
			coreApp.initDefault();
		},
		isHasIOSline: function () {
			const hasHomeIndicator =
				window.safeAreaInsets && window.safeAreaInsets.bottom > 0;
			if (hasHomeIndicator) {
				$body.classList.add("is-iosline");
			}
		},
		isTouchDevice: function () {
			try {
				document.createEvent("TouchEvent");
				return true;
			} catch (e) {
				return false;
			}
		},

		initPhoneMask: function () {
			const inputs = document.querySelectorAll("input[type=tel]");
			if (inputs) {
				inputs.forEach((el) => {
					VMasker(el).maskPattern("9 (999) 999-99-99");
				});
			}
		},
		initMoreLinks: function () {
			const moreBlocks = document.querySelectorAll(
				".js-morecrop:not(.is-proceed)"
			);
			if (moreBlocks) {
				moreBlocks.forEach((el) => {
					const link = document.createElement("span");
					let linkTruncate = 1;

					let lines = el.querySelectorAll("p");
					let names = "ещё,свернуть";
					if (el.dataset.cropNames) {
						names = el.dataset.cropNames;
					}
					if (el.dataset.crop) {
						linkTruncate = el.dataset.crop;
					}
					names = names.split(",");
					let linkPositionInArray = linkTruncate - 1;
					link.className = "link link--more js-morecrop-link";
					link.innerText = names[0];

					if (lines.length > linkTruncate) {
						lines[linkPositionInArray].appendChild(link);
					}

					let linkEl = el.querySelector(".js-morecrop-link");

					if (linkEl) {
						linkEl.addEventListener("click", () => {
							const isActive = el.classList.contains("is-open");
							el.classList.toggle("is-open");
							linkEl.innerHTML = isActive ? names[0] : names[1];
						});
					}
					el.classList.add("is-proceed");
				});
			}
		},
		initWebPcheck: function () {
			const canvas = document.createElement("canvas");
			const supportsWebP =
				!!(canvas.getContext && canvas.getContext("2d")) &&
				canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0;
			$body.classList.add(supportsWebP ? "is-webp" : "is-no-webp");
		},
		initResize: function () {
			menuApp.default();
			console.log('resize')
		},
		initClearHandlers: function () {
			const el = document.querySelector(".js-clear-handlers");
			if (el) {
				el.addEventListener("click", () => {
					coreApp.clearHandlers();
					popupApp.clear();
					mobilePopupApp.clear();
					menuApp.reset();
					/*
					let menuOpen = document.querySelectorAll('.js-mainmenu .is-open');
					menuOpen.forEach(item => {
						item.classList.remove('is-open');
					})
						*/
				});
			}
		},
		clearHandlers: function () {
			$body.classList.remove.apply(
				$body.classList,
				Array.from($body.classList).filter((v) => v.startsWith("js-"))
			);
		},
		loader: function (name = "show") {
			const type = name;
			const loader = document.querySelector(".r_loader");
			const createLoader = () => {
				const el = document.createElement("div");
				el.setAttribute("class", "r_loader");
				Array.from({ length: 12 }, () => document.createElement("i")).forEach(
					(newElement) => el.appendChild(newElement)
				);
				$body.appendChild(el);
			};
			switch (type) {
				case "show":
					if (!loader) createLoader();
					$body.classList.add("js-loader-show");
					break;
				case "hide":
					$body.classList.remove("js-loader-show");
					break;
				case "create":
					if (!loader) createLoader();
					break;
			}
		},

		getViewPort: function () {
			const e = window,
				a = "inner";
			if (!("innerWidth" in window)) {
				a = "client";
				e = document.documentElement || $body;
			}
			return { width: e[a + "Width"], height: e[a + "Height"] };
		},
		/*
		getBreakpoint: function (size) {
			const sizes = {'xs': 0, 'sm': 576, 'md': 768, 'lg': 992, 'xl': 1200, 'xxl': 1400};
			return sizes[size] ?? 0;
		},
		*/
		getEmailFilter: function () {
			return {
				filter:
					/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
			};
		},
		declinationText: function (n, r) {
			var t = Math.round(n), a = ["товар", "товара", "товаров"];
			r && (a = r);
			return a[t % 100 > 4 && t % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][t % 10 < 5 ? t % 10 : 5]]
		},
		
		getScrollbarWidth: function () {
			if (!document.querySelector(".r_scrolldetect")) {
				div = document.createElement("div");
				div.className = "r_scrolldetect";
				Object.assign(div.style, {
					width: "100px",
					height: "100px",
					overflow: "scroll",
					position: "absolute",
					top: "-9999px",
				});
				$body.appendChild(div);
			}
			const scrollDiv = document.querySelector(".r_scrolldetect");
			const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
			$body.removeChild(scrollDiv);
			return scrollbarWidth;
		},
		 
		getCookie: function(name){
			const encodedName = `${encodeURIComponent(name)}=`;
			const cookies = document.cookie.split(';').map(cookie => cookie.trim());
			const cookie = cookies.find(cookie => cookie.startsWith(encodedName));
			return cookie ? decodeURIComponent(cookie.substring(encodedName.length)) : null;
		},
		setCookie: function(name, value, days = 7){
			const expires = new Date(Date.now() + days * 864e5).toUTCString(); 
			document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
		},
		getFormBlock: function (formElement, disable = true) { 
 
			if (!formElement || !(formElement instanceof HTMLElement)) {
				console.error('Provided argument is not a valid HTML element.');
				return;
			}
 
			const formControls = formElement.querySelectorAll('.input, .btn');
			const submitButton = formElement.querySelector('[type="submit"], .btn-submit');
 
			formControls.forEach(control => {
				control.disabled = disable;
			}); 

			if (submitButton) {
				submitButton.disabled = disable;
				const buttonText = submitButton.textContent;
				if (disable) { 
					submitButton.innerHTML = `
							<span class="btn__text">${buttonText}</span>
							<span class="btn__loading"><span></span><span></span><span></span><span></span></span>
							`;
					submitButton.style.width = `${submitButton.offsetWidth}px`;
					submitButton.classList.add('is-loading'); 
				} else {
					submitButton.removeAttribute('style');
					submitButton.classList.remove('is-loading');
				}
			}  
		},
		getFormReset: function (formElement) {

			if (!formElement || !(formElement instanceof HTMLElement)) {
				console.error('Provided argument is not a valid HTML element.');
				return;
			}  
 
			const elementsWithErrors = formElement.querySelectorAll('.is-error, .is-success');
			elementsWithErrors.forEach(el => {
					el.classList.remove('is-error', 'is-success');
			});

			formElement.reset();
 
				/*
			//const formControls = formElement.querySelectorAll('input, select, textarea');
			const formControls = formElement.querySelectorAll('.input');
			formControls.forEach(control => {
					if (control.type === 'checkbox' || control.type === 'radio') {
							control.checked = false;
					} else {
							control.value = '';
					}
			});
*/
			

		},
		initFormSuccess: function(formElement){

			if (!formElement || !(formElement instanceof HTMLElement)) {
				console.error('Provided argument is not a valid HTML element.');
				return;
			} 

			const successMsg = formElement.querySelector('.form__group--complete');
			if(successMsg){
				successMsg.classList.remove('is-shown');
			}

			/*
			const openedPopup = document.querySelector('.popup.is-shown');
			if(openedPopup){
				openedPopup.classList.add('is-shown-success')
			}
			*/

		},
		initFormCheck: function () {
			const formsToCheck = document.querySelectorAll('[data-form]');

			formsToCheck.forEach(form => {
				const inputs = form.querySelectorAll('.input');

				const validateInput = (input) => {
					const formGroup = input.closest('.form__group');
					formGroup.classList.remove('is-success', 'is-error');

					if (input.value !== '') {
						if (input.type === 'email' && input.hasAttribute('data-required')) {
							const isValidEmail = coreApp.getEmailFilter().filter.test(input.value);
							formGroup.classList.toggle('is-success', isValidEmail);
							formGroup.classList.toggle('is-error', !isValidEmail);
						} else if (input.hasAttribute('data-required') || input.type !== 'email') {
							formGroup.classList.add('is-success');
						}
					} else if (input.hasAttribute('data-required')) {
						formGroup.classList.add('is-error');
					}
				};

				const clearErrorOnInput = (event) => {
					const target = event.target;
					if (target.matches('.is-error .input, .input.is-error')) {
						const errorParent = target.closest('.is-error');
						if (errorParent) {
							errorParent.classList.remove('is-error');
						}
					}
				};

				inputs.forEach(input => {
					if (form.hasAttribute('data-live-check')) {

						input.addEventListener('change', () => validateInput(input));
						input.addEventListener('keyup', () => validateInput(input));

						if (input.type === 'checkbox' || input.type === 'radio') {
							input.checked = false;
						} else {
							input.value = '';
						}
					} else {
						input.addEventListener('change', clearErrorOnInput);
						input.addEventListener('keyup', clearErrorOnInput);
					}
				});
			});
		},
		getFormValidation: function (el) {
			const form = el;
			const inputs = form.querySelectorAll('[data-required]');
			const selectBoxes = form.querySelectorAll('.selectBox.is-not-selected');
			let hasError = false;

			inputs.forEach(input => {
				const { value, checked, type, dataset } = input;
				const errorText = dataset.errorText || 'Заполните обязательное поле';
				const formGroup = input.closest('.form__group');

				let isError = !value || (type === 'checkbox' && !checked);

				if (type === 'email') {
					isError = isError || !coreApp.getEmailFilter().filter.test(value);
				}
				/*
				if (type === 'tel') { 
					const phoneRegex = /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
					isError = isError || !phoneRegex.test(value);
				}
				*/

				if (isError) {
					formGroup.classList.remove('is-success');
					formGroup.classList.add('is-error');
					hasError = true;

					const hintContainer = formGroup.querySelector('.form__group_hints');
					if (hintContainer && !hintContainer.querySelector('.hint__item--error')) {
						const errorContainer = document.createElement('div');
						errorContainer.className = 'hint__item hint__item--error';
						errorContainer.textContent = errorText;
						hintContainer.prepend(errorContainer);
					}
				} else {
					formGroup.classList.remove('is-error');
					formGroup.classList.add('is-success');
				}
			});

			if (selectBoxes.length > 0) {
				selectBoxes.forEach(selectBox => {
					selectBox.closest('.form__group').classList.add('is-error');
				});
				hasError = true;
			}

			coreApp.loader('hide');
			return hasError;
		}, 
		initFormRestrictRules: function () {
			const uiFormInputRestrict = document.querySelectorAll("*[data-allow]");
			uiFormInputRestrict.length &&
				uiFormInputRestrict.forEach((item) => {
					item.addEventListener("keydown", (e) => {
						const allow = item.dataset.allow;
						const key = e.keyCode;
						const base = [8, 9, 27];
						const numbers = [...Array(10).keys()]
							.map((i) => i + 48)
							.concat([...Array(10).keys()].map((i) => i + 96));
						const spec = [
							189, 187, 219, 221, 220, 186, 222, 191, 110, 111, 106, 109, 107,
							192,
						];
						const isNumericKey = numbers.includes(key);
						const isSpecialKey = spec.includes(key);
						if (allow === "abc" && (isSpecialKey || isNumericKey)) {
							e.preventDefault();
						}
						if (allow === "num") {
							if (
								base.includes(key) ||
								(key === 65 && e.ctrlKey) ||
								(key >= 35 && key <= 40)
							) {
								return;
							}
							if (
								(e.shiftKey || key < 48 || key > 57) &&
								(key < 96 || key > 105)
							) {
								e.preventDefault();
							}
						}
					});
				});
		},
		setScrollbarWidth: function () {
			let scrollWidth = coreApp.getScrollbarWidth();
			$html.setAttribute("style", "--scrollbar-width: " + scrollWidth + "px");
		},
		initDefault: function () {
			$html.classList.remove("no-js"); // check js support

			$body.classList.add(
				coreApp.isTouchDevice() ? "is-touchdevice" : "is-no-touchdevice"
			); // check touchdevice support
			coreApp.initWebPcheck(); // check webp support
			coreApp.isHasIOSline(); // check for ios bottom line
			coreApp.loader("create"); // create loader in DOM
			coreApp.initFormCheck(); 
			coreApp.initFormRestrictRules(); // init custom restricts for inputs
			coreApp.initPhoneMask(); // set phone masks
			//coreApp.getResetError(); // reset form errors
			coreApp.initClearHandlers();
			coreApp.setScrollbarWidth();
			coreApp.initMoreLinks();
		},
	};
})();

// popup app
const popupApp = (function () {
	return {
		init: function () {
			popupApp.close();

			const uiPopupLinks = document.querySelectorAll("*[data-popup]");
			if (uiPopupLinks.length) {
				uiPopupLinks.forEach((link) => {
					link.addEventListener("click", (e) => {
						e.preventDefault();
						let linkData = link.dataset.popup;
						popupApp.open(linkData);
						return false;
					});
				});
			}
		},
		complete: function (name) {
			let popup = document.querySelector(".popup--" + name);
			popup.classList.add("is-complete");
		},
		clear: function () {
			$body.classList.remove("js-popup-show");
			const popups = document.querySelectorAll(".popup.is-shown");
			if (popups.length) {
				popups.forEach((item) => {
					item.classList.remove("is-shown");
				});
			}

			$body.removeAttribute("style");
		},
		close: function (a) {
			const getPopups = document.querySelectorAll(".popup .js-close");

			if (getPopups.length) {
				getPopups.forEach((popup) => {
					popup.addEventListener("click", () => {
						popupApp.clear();
					});
				});
			}
		},
		center: function (a) {
			let name = a;
			let popup = document.querySelector(".popup--" + name);
			var popupInner = popup.querySelector(".popup__inner");
			let scrollWidth = coreApp.getScrollbarWidth();
			$body.setAttribute("style", "--scrollbar-width: " + scrollWidth + "px");
			popup.classList.remove("is-complete");
			if (popupInner.outerHeight > coreApp.getViewPort().height) {
				popup.classList.add("is-align-top");
			} else {
				popup.classList.remove("is-align-top");
			}

			$body.classList.add("js-popup-show");
			popup.classList.add("is-shown");
		},
		open: function (a, b) {
			let popup = a;
			if ($body.classList.contains("js-popup-show")) {
				popupApp.clear();
			}

			if (popup == "wishlist-appointment") {
				shopsApp.openPopupState();
				shopsApp.initPopup();
			}

			const popupForm = document.querySelector(
				".popup--" + popup + " .form.is-need-reset"
			);

			if (popupForm) {
				let formClass =
					"." + popupForm.querySelector("form").getAttribute("class");
				coreApp.uiFormBlock({ form: formClass, block: false });
				coreApp.getResetForm(popupForm);
			}
			popupApp.center(popup);
		},
	};
})();

/* mobile popups */
const mobilePopupApp = (function () {
	return { 
		clear: function () {
			$body.classList.remove("is-m-popup-show");
			const popups = document.querySelectorAll(".m_popup.is-shown");
			if (popups.length) {
				popups.forEach((item) => {
					item.classList.remove("is-shown");
				});
			} 
			$body.removeAttribute("style");
		},  
		open: function (name) {
			let popup = document.querySelector(".m_popup--" + name);
			if ($body.classList.contains("js-popup-show")) {
				mobilePopupApp.clear();
			}  
			$body.classList.add("is-m-popup-show");
			popup.classList.add("is-shown");
			  
		},
	};
})();

// components app
const componentsApp = (function () {
	return {
		init: function () { 
			popupApp.init();
			componentsApp.scrollToTop(); 
			componentsApp.scrollToTarget();
			componentsApp.fixedHeader();
			componentsApp.qty();
			componentsApp.tabs();
			componentsApp.fancybox();
			componentsApp.wrapTables();  
			//componentsApp.useEditorCrop(); 
			componentsApp.initVideoControls();
			componentsApp.initAnimations();
			componentsApp.initCarousels();
		},
		initCarousels: function(){
			const productsCarousel = document.querySelectorAll(".js-products-carousel");
			if (productsCarousel) {
				productsCarousel.forEach((item) => {
					let carousel = item.querySelector(".swiper");
					let btnNext = item.querySelectorAll(".js-button-next");
					let btnPrev = item.querySelectorAll(".js-button-prev");
					let pager = item.querySelectorAll(".js-dots-pagination");

					if (carousel && btnNext && btnPrev) {
						new Swiper(carousel, {
							spaceBetween: 10,
							slidesPerView: 2,
							autoHeight: true,
							breakpoints: {
								0: { slidesPerView: 1}, 
								992: { slidesPerView: 2}, 
								1400: { slidesPerView: 3, spaceBetween: 24 } 
							},
							navigation: { nextEl: Array.from(btnNext), prevEl: Array.from(btnPrev)},
							pagination: {
								el:  Array.from(pager),
								clickable: true
							}
						});
					}
				});
			}
		},
		initVideoControls: function(){
			
			document.querySelectorAll('.js-video-play').forEach(button => {
				button.addEventListener('click', () => {
					const mediaBlock = button.closest('.r_media');
					if (!mediaBlock) return; 
					const video = mediaBlock.querySelector('video');
					if (!video) return;

					video.play()
						.then(() => {
						mediaBlock.classList.add('is-played');
						})
						.catch(error => {
						console.error('Error:', error);
						});
				});
			});


			document.querySelectorAll('.js-video-pause').forEach(button => {
				button.addEventListener('click', () => {
					const mediaBlock = button.closest('.r_media');
					if (!mediaBlock) return;

					const video = mediaBlock.querySelector('video');
					if (!video) return;

					video.pause();
					mediaBlock.classList.remove('is-played');
				});
			});

			document.querySelectorAll('.js-video-sound-toggle').forEach(button => {
				button.addEventListener('click', () => {
					const mediaBlock = button.closest('.r_media');
					if (!mediaBlock) return;

					const video = mediaBlock.querySelector('video');
					if (!video) return;

					video.muted = !video.muted;

					if (!video.muted) {
						mediaBlock.classList.add('is-sound-on');
					} else {
						mediaBlock.classList.remove('is-sound-on');
					}
				});
			});
		}, 
		fixedHeader: function () {
				const header = document.querySelector(".header");
				const totopButton = document.querySelector(".js-scroll-top");
				const body = document.body;
				let lastScrollTop = 0;
				let ticking = false;
				let headerHasWhiteBg = false;

				function onScroll() {
					const scrollTop = Math.round(window.pageYOffset);
					const headerHeight = header.offsetHeight;
					const shouldFixHeader = scrollTop > headerHeight;
 
					const isCurrentlyFixed = body.classList.contains("is-fixed-header");
					if (shouldFixHeader !== isCurrentlyFixed) {
						body.classList.toggle("is-fixed-header", shouldFixHeader);
					} 

					if (scrollTop > 40 && !headerHasWhiteBg) {
						header.style.background = "#fff";
						headerHasWhiteBg = true;
					} else if (scrollTop <= 40 && headerHasWhiteBg) {
						header.removeAttribute("style");
						headerHasWhiteBg = false;
					}
 
					if (totopButton) {
						const shouldShowTotop =
							scrollTop > headerHeight * 6 &&
							coreApp.getViewPort().width > 576;
						const isShown = body.classList.contains("is-show-totop");
						if (shouldShowTotop !== isShown) {
							body.classList.toggle("is-show-totop", shouldShowTotop);
						}
					}

					lastScrollTop = scrollTop;
					ticking = false;

					
				}
				window.addEventListener("scroll", () => {
						if (!ticking) {
							requestAnimationFrame(onScroll);
							ticking = true;
						}
					});
		},
		initAnimations: function () {
			const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "is-animate";
			const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "is-animate--offscreen";
			const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = "is-animate--zoom-in";
			const SCROLL_ANIMATION_CANCEL_CLASSNAME = "is-animate--cancel";

			// Scroll in animation logic
			function onIntersection(elements, observer) {
				elements.forEach((element, index) => {
					if (element.isIntersecting) {
						const elementTarget = element.target;
						if (
							elementTarget.classList.contains(
								SCROLL_ANIMATION_OFFSCREEN_CLASSNAME
							)
						) {
							elementTarget.classList.remove(
								SCROLL_ANIMATION_OFFSCREEN_CLASSNAME
							);
							if (elementTarget.hasAttribute("data-animate-cascade"))
								elementTarget.setAttribute(
									"style",
									`--animation-order: ${index};`
								);
						}
						observer.unobserve(elementTarget);
					} else {
						element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
						element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
					}
				});
			}
			function initializeScrollAnimationTrigger(
				rootEl = document,
				isDesignModeEvent = false
			) {
				const animationTriggerElements = Array.from(
					rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
				);
				if (animationTriggerElements.length === 0) return;

				if (isDesignModeEvent) {
					animationTriggerElements.forEach((element) => {
						element.classList.add(".is-animate--design-mode");
					});
					return;
				}

				const observer = new IntersectionObserver(onIntersection, {
					rootMargin: "0px 0px -50px 0px",
				});
				animationTriggerElements.forEach((element) =>
					observer.observe(element)
				);
			}

			// Zoom in animation logic
			function initializeScrollZoomAnimationTrigger() {
				if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
					return;

				const animationTriggerElements = Array.from(
					document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME)
				);

				if (animationTriggerElements.length === 0) return;

				const scaleAmount = 0.2 / 100;

				animationTriggerElements.forEach((element) => {
					let elementIsVisible = false;
					const observer = new IntersectionObserver((elements) => {
						elements.forEach((entry) => {
							elementIsVisible = entry.isIntersecting;
						});
					});
					observer.observe(element);

					element.style.setProperty(
						"--zoom-in-ratio",
						1 + scaleAmount * percentageSeen(element)
					);

					window.addEventListener(
						"scroll",
						throttle(() => {
							if (!elementIsVisible) return;

							element.style.setProperty(
								"--zoom-in-ratio",
								1 + scaleAmount * percentageSeen(element)
							);
						}),
						{ passive: true }
					);
				});
			}

			function percentageSeen(element) {
				const viewportHeight = window.innerHeight;
				const scrollY = window.scrollY;
				const elementPositionY = element.getBoundingClientRect().top + scrollY;
				const elementHeight = element.offsetHeight;

				if (elementPositionY > scrollY + viewportHeight) {
					// If we haven't reached the image yet
					return 0;
				} else if (elementPositionY + elementHeight < scrollY) {
					// If we've completely scrolled past the image
					return 100;
				}

				// When the image is in the viewport
				const distance = scrollY + viewportHeight - elementPositionY;
				let percentage = distance / ((viewportHeight + elementHeight) / 100);
				return Math.round(percentage);
			}

			window.addEventListener("DOMContentLoaded", () => {
				initializeScrollAnimationTrigger();
				initializeScrollZoomAnimationTrigger();
			});
		}, 
		fancybox: function () {
			Fancybox.bind("*[data-fancybox]", {});
		},
		wrapTables: function () {
			document
				.querySelectorAll(".editor table:not(.is-proceed)")
				.forEach((table) => {
					const outerDiv = document.createElement("div");
					outerDiv.classList.add("r_table");
					const innerDiv = document.createElement("div");
					innerDiv.classList.add("r_table__inner");
					table.parentNode.insertBefore(outerDiv, table);
					outerDiv.appendChild(innerDiv);
					innerDiv.appendChild(table);
					table.classList.add("is-proceed");
				});
		},
		/*
		useEditorCrop: function () {
			const cutContainers = document.querySelectorAll(
				".is-text-truncate:not(.is-proceed)"
			);

			cutContainers.forEach((container) => {
				const textContent = container.querySelector("p");
				const names = (
					container.dataset.cropNames || "Развернуть,Свернуть"
				).split(",");
				const [expandText, collapseText] = names;
				const toggleButton = document.createElement("span");

				toggleButton.className = "link link--toggleCrop";
				toggleButton.textContent = expandText;
				container.appendChild(toggleButton);

				const updateClamping = () => {
					const lineHeight = parseFloat(
						window.getComputedStyle(textContent).lineHeight
					);
					const maxLines = 5;
					textContent.style.setProperty("-webkit-line-clamp", maxLines);
				};

				const toggleContent = () => {
					const isExpanded = container.classList.toggle("is-crop-shown-more");
					toggleButton.textContent = isExpanded ? collapseText : expandText;
				};

				const updateVisibility = () => {
					container.classList.toggle(
						"is-crop-shown-button",
						textContent.scrollHeight > textContent.clientHeight
					);
				};

				toggleButton.addEventListener("click", toggleContent);

				const updateLayout = () => {
					updateClamping();
					updateVisibility();
				};
				updateLayout();
				window.addEventListener("resize", updateLayout);
				container.classList.add("is-proceed");
			});
		},
		*/
		tabs: function () {
			const allTabs = document.querySelectorAll(".js-tabs");
			if (allTabs) {
				allTabs.forEach((el) => {
					const settings = {
						type: el.getAttribute("data-type") || "tabs",
						breakpoint: el.getAttribute("data-breakpoint") || 992,
						carousel: false,
					};

					if (settings.type == "accordeon") {
						el.classList.remove("r_tabs--tabs");
						el.classList.add("r_tabs--accordeon");
					}
					el.querySelectorAll(".js-tabs-links > *").forEach((element) => {
						const target = element.dataset.tab;
						const newItem = el
							.querySelector(`*[data-tab-target="${target}"]`)
							.insertBefore(
								document.createElement("div"),
								el.querySelector(`*[data-tab-target="${target}"]`)
									.firstElementChild
							);

						newItem.className = "r_tabs__item_title";
						newItem.setAttribute("data-tab", target);
						newItem.textContent = element.textContent;
					});

					el.querySelectorAll("*[data-tab]").forEach((tab) => {
						tab.addEventListener("click", () => {
							const id = tab.dataset.tab;
							if (
								settings.type == "accordeon" ||
								coreApp.getViewPort().width < settings.breakpoint
							) {
								tab.closest("[data-tab]").classList.toggle("is-selected");
								el.querySelector(`*[data-tab-target="${id}"]`).classList.toggle(
									"is-selected"
								);
							} else {
								el.querySelectorAll("[data-tab], [data-tab-target]").forEach(
									(item) => {
										item.classList.remove("is-selected");
									}
								);
								tab.closest("[data-tab]").classList.add("is-selected");
								el.querySelector(`*[data-tab-target="${id}"]`).classList.add(
									"is-selected"
								);
							}
						});
					});

					if (
						settings.type === "tabs" &&
						coreApp.getViewPort().width > settings.breakpoint
					) {
						el.querySelector(
							".r_tabs__links [data-tab]:first-child"
						).classList.add("is-selected");
						el.querySelector(
							".r_tabs__wrapper [data-tab-target]:first-child"
						).classList.add("is-selected");
					}
				});
			}
		},
		scrollToTarget: function () {
			const el = document.querySelectorAll("*[data-scroll]");
			if (el) {
				el.forEach((item) => {
					item.addEventListener("click", () => {
						const header = document.querySelector(".header").offsetHeight;
						let minusHeight = (header * 1.2) + 70;

						const target = item.getAttribute("data-scroll");
						const targetElement = document.querySelector(`.${target}`);

						if (targetElement) {
							window.scrollTo({
								top: targetElement.offsetTop - minusHeight,
								behavior: "smooth",
							});
						}
					});
				});
			}
		},
		scrollToTop: function () {
			if (!document.querySelector(".js-scroll-top")) {
				linkTop = document.createElement("div");
				linkTop.className = "r_totop js-scroll-top";
				//linkTop.innerHTML = 'top';
				$body.appendChild(linkTop);
			}
			document.querySelector(".js-scroll-top").addEventListener("click", () => {
				window.scrollTo({ top: 0, behavior: "smooth" });
				return false;
			});
		},
		qty: function () {
			const el = document.querySelectorAll(".js-qty");

			if (el) {
				el.forEach((item) => {
					const input = item.querySelector(".js-qty-input");
					const btnPlus = item.querySelector(".js-qty-plus");
					const btnMinus = item.querySelector(".js-qty-minus");

					btnPlus.addEventListener("click", () => {
						if (!input.disabled) {
							input.value = Number(input.value) + 1;
						}
					});

					btnMinus.addEventListener("click", () => {
						if (!input.disabled) {
							input.value = Math.max(1, Number(input.value) - 1);
							input.dispatchEvent(new Event("change", { bubbles: true }));
						}
					});

					input.addEventListener("change", () => {
						if (!input.disabled) {
							input.value = Math.max(1, Number(input.value));
						}
					});
				});
			}
		} 
	};
})();

// formHandlerApp
const formHandlerApp = (function () {
	let form, formSelector;

	const initSubmit = (el) => {
		form = document.querySelector(formSelector);
		if (coreApp.getFormValidation(form)) return;

		coreApp.uiFormBlock({ form: formSelector });

		const formData = new URLSearchParams(new FormData(form));
		const requestOptions = {
			method: "POST",
			body: formData,
		};

		if (formSelector === ".js-customsize-form") {
			sendCustomSizeForm();
		}
	};

	const initComplete = () => {
		form = document.querySelector(formSelector);
		const successMsg = form.querySelector(".form__group--complete");
		if (successMsg) {
			successMsg.classList.add("is-shown");
		}
		coreApp.uiFormBlock({ form: formSelector, block: false });
		setTimeout(() => coreApp.getResetForm(form), 4000);
	};

	return {
		init: function (el) {
			formSelector = el;
			initSubmit();
		},
		initComplete,
	};
})();

// init apps
coreApp.init();
componentsApp.init();


var accItemsHeaders = document.querySelectorAll(
	".js-accordeon .r_acc__item_header"
);
if (accItemsHeaders.length) {
	accItemsHeaders.forEach(function (header) {
		header.addEventListener("click", function () {
			var parentItem = this.closest(".r_acc__item");
			if (parentItem.classList.contains("is-open")) {
				parentItem.classList.remove("is-open");
			} else {
				parentItem.classList.add("is-open");
			}
		});
	});
}

// home main slider
const homeSlider = new Swiper('.js-mainbanner-carousel.is-interactive .swiper', {
	speed:600, 
	autoHeight: true,
	effect: 'fade',
	watchSlidesVisibility: true, 
	slidesPerView: 1,
	spaceBetween: 0,
	autoplay: {
		delay: 3000,
		disableOnInteraction: true
	},
	navigation: {nextEl: '.js-mainbanner-carousel .js-button-next',prevEl: '.js-mainbanner-carousel .js-button-prev'},
	pagination: {el: '.js-mainbanner-carousel .js-dots-pagination',clickable: true}, 
});



const galleryThumbs = new Swiper('.js-gallery-thumbs .swiper', {
				  
	slidesPerView: 'auto',
	spaceBetween: 12,
	freeMode: true,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	navigation: {nextEl: '.js-gallery-thumbs .js-button-right',prevEl: '.js-gallery-thumbs .js-button-left'},
	breakpoints: { 
		0: {
			 
			slidesPerView:4
		},
		1400: {  
			direction: 'vertical'
		}
	},
	scrollbar: {
		el: ".js-gallery-thumbs .swiper-scrollbar",
		hide: false
	}
});

const galleryPreview = new Swiper('.js-gallery-preview .swiper', {
	watchSlidesVisibility:true,
	spaceBetween: 0,
	thumbs: {swiper: galleryThumbs},
	navigation: {nextEl: '.js-gallery-preview .js-button-right',prevEl: '.js-gallery-preview .js-button-left'},
	pagination: {el: '.js-gallery-preview .js-dots-pagination',clickable: true}, 
});

 
const subcollectionsCarousel = new Swiper(
	".js-subcollections-carousel .swiper",
	{
		spaceBetween: 20,
		slidesPerView: 6,
		breakpoints: {
			0: { slidesPerView: 1, spaceBetween: 10},
			360: { slidesPerView: 2 },
			768: { slidesPerView: 3 },
			992: { slidesPerView: 4 },
			1600: { slidesPerView: 6 }
		},
		navigation: {
			nextEl: ".js-subcollections-carousel .js-button-right",
			prevEl: ".js-subcollections-carousel .js-button-left",
		},
	}
);

let searchButtons = document.querySelectorAll(".js-search-toggle");
if (searchButtons.length) {
	searchButtons.forEach((item) => {
		item.addEventListener("click", () => {
			$body.classList.toggle("js-show-search");
			document.querySelector(".search .search__item_input").focus();
		});
	});
}

let filterToggle = document.querySelectorAll(".js-toggle-filter");
if (filterToggle.length) {
	filterToggle.forEach((item) => {
		item.addEventListener("click", () => {
			$body.classList.toggle("js-show-filter");
		});
	});
}



let filterGroup = document.querySelectorAll("#filter .filter__group .filter__group_title");
if (filterGroup.length) {
	filterGroup.forEach((item) => {
		item.addEventListener("click", () => {
			item.closest(".filter__group").classList.toggle("is-open");
		});
	});
}

document
	.querySelectorAll(".js-selectbox .selectBox__name")
	.forEach(function (selectBoxName) {
		selectBoxName.addEventListener("click", function () {
			let item = this.closest(".js-selectbox");
			if (item.classList.contains("is-open")) {
				item.classList.remove("is-open");
			} else {
				if (coreApp.getViewPort().width > 991) {
					document
						.querySelectorAll(".js-selectbox.is-open")
						.forEach(function (openSelectBox) {
							openSelectBox.classList.remove("is-open");
						});
				}
				item.classList.add("is-open");
			}
		});
	});


	
const bannersAboutCarousel = document.querySelectorAll(".js-banners-about");
if (bannersAboutCarousel) {
	bannersAboutCarousel.forEach((item) => {
			let carousel = item.querySelector(".swiper");
			let btnNext = item.querySelectorAll(".js-button-next");
			let btnPrev = item.querySelectorAll(".js-button-prev");
	
			if (carousel && btnNext && btnPrev) {
				new Swiper(carousel, {
					spaceBetween: 20,
					slidesPerView: 2, 
					breakpoints: {
						0: { slidesPerView: 2}, 
						576: { slidesPerView: 3 },
						768: { slidesPerView: 4 } 
					},
					navigation: { nextEl: Array.from(btnNext), prevEl: Array.from(btnPrev) }
				});
			}
		});
	}

	
	const contactsCarousel = document.querySelectorAll(".js-location-gallery");
if (contactsCarousel) {
	contactsCarousel.forEach((item) => {
		let carousel = item.querySelector(".swiper");
		let btnNext = item.querySelectorAll(".js-button-next");
		let btnPrev = item.querySelectorAll(".js-button-prev");

		if (carousel && btnNext && btnPrev) {
			new Swiper(carousel, {
				spaceBetween: 10,
				slidesPerView: 2,
				freemode: true,
				slidesPerView: 'auto',
				navigation: { nextEl: Array.from(btnNext), prevEl: Array.from(btnPrev) }
			});
		}
	});
}



document.querySelectorAll('.js-open-gift-popup').forEach(button => {
	button.addEventListener('click', function(e) {
		 e.stopPropagation();
		 document.querySelector('.js-gift-popup').classList.toggle('is-open');
	});
});

document.addEventListener('click', function(e) {
	const popup = document.querySelector('.js-gift-popup');
	const button = document.querySelector('.js-open-gift-popup'); 
	if(popup){
		if (!popup.contains(e.target) && !button.contains(e.target)) {
			popup.classList.remove('is-open');
	  }
	}

});






const bannersCarousel = document.querySelectorAll(".js-banners-carousel");
if (bannersCarousel) {
	bannersCarousel.forEach((item) => {
		let carousel = item.querySelector(".swiper");
		let btnNext = item.querySelectorAll(".js-button-next");
		let btnPrev = item.querySelectorAll(".js-button-prev");

		if (carousel && btnNext && btnPrev) {
			new Swiper(carousel, {
				spaceBetween: 10,
				slidesPerView: 1,
				watchSlidesVisibility: true,
				watchSlidesProgress: true, 
				breakpoints: {
					0: { slidesPerView: 1 },
					768: { slidesPerView: 2},
					992: {slidesPerView: 2, spaceBetween: 20}  
				},
				navigation: { nextEl: Array.from(btnNext), prevEl: Array.from(btnPrev) }
			});
		}
	});
}



if (document.querySelectorAll('.js-banners-card').length) {
	const bannerCarouselTarget = window.matchMedia('(max-width: 575px)');
	let bannerCarousel;

	const bannerCarouselCheck = () => {
		 if (bannerCarouselTarget.matches) {
			  if (bannerCarousel !== undefined) bannerCarousel.destroy(true, true);
			  return;
		 } else {
			  bannerCarouselInit();
		 }
	};

	const bannerCarouselInit = () => {
		 document.querySelectorAll('.js-banners-card').forEach(card => {
			  const carousel = card.querySelector('.swiper');
			  const btnNext = card.querySelector('.js-button-right');
			  const btnPrev = card.querySelector('.js-button-left');
			  const pager = card.querySelector('.js-swiper-pagination');

			  const bannerCarousel = new Swiper(carousel, {
					spaceBetween: 0,
					slidesPerView: 1,
					navigation: {
						 nextEl: btnNext,
						 prevEl: btnPrev
					},
					pagination: {
						 el: pager,
						 clickable: true,
						 renderBullet: (index, className) =>
							  `<span class="${className}" data-slide-index="${index}"></span>`
					}
			  });

			  card.querySelectorAll('.js-swiper-pagination span').forEach((bullet, index) => {
					bullet.addEventListener('mouseenter', () => {
						 bannerCarousel.slideToLoop(index);
					});
			  });
		 });
	};

	bannerCarouselTarget.addEventListener('change', bannerCarouselCheck);
	bannerCarouselCheck();
}



document
	.querySelectorAll(".js-selectbox .selectBox__option")
	.forEach(function (selectBoxOption) {
		selectBoxOption.addEventListener("click", function (e) {
			e.preventDefault();
			let selectBoxParent = this.closest(".js-selectbox");
			selectBoxParent
				.querySelector(".is-selected")
				.classList.remove("is-selected");
			this.closest(".selectBox__dd_item").classList.add("is-selected");
			selectBoxParent.classList.remove("is-not-selected");
			selectBoxParent.querySelector(".selectBox__value").innerHTML =
				this.getAttribute("data-value");
			selectBoxParent.classList.remove("is-open");
		});
	});

$body.addEventListener("click", function (e) {
	if (!e.target.closest(".js-selectbox")) {
		document
			.querySelectorAll(".js-selectbox.is-open")
			.forEach(function (openSelectBox) {
				openSelectBox.classList.remove("is-open");
			});
	}
});

/*
let menuItem = document.querySelectorAll(".toolbar--left .item");
let toolbar = document.querySelector('.toolbar--left');

menuItem.forEach(function (item) {
	 item.addEventListener('click', function(){
		item.classList.toggle('is-open');
		let opened = document.querySelectorAll(".toolbar--left .item.is-open");
		
		if(opened.length){
			toolbar.classList.add('is-opened');
		}else{
			toolbar.classList.remove('is-opened');
		}
	 })
});
*/

 

const mainMenu = document.querySelector('.js-mainmenu');
 
const updateBodyClass = () => {
	const hasOpenClass = document.querySelector('.js-mainmenu .is-dd.is-open');
	document.body.classList.toggle('js-show-mainmenu-dd', Boolean(hasOpenClass));
};

const menuLinks = document.querySelectorAll('.js-mainmenu .js-menu-toggle');


menuLinks.forEach(item => {
    item.addEventListener('click', (e) => {
        e.preventDefault();
        const currentDD = item.closest('.is-dd');
        const isOpen = currentDD.classList.contains('is-open');
        document.querySelectorAll('.js-mainmenu .is-dd.is-open').forEach(openItem => {
            openItem.classList.remove('is-open');
        });
        if (!isOpen) {
            currentDD.classList.add('is-open');
        }
        updateBodyClass();
    }); 
});


const submenuLinks = document.querySelectorAll('.js-mainmenu .js-submenu-toggle');

function handleSubmenuToggle() {
  if (window.innerWidth < 1200) {
    submenuLinks.forEach(item => {
      if (!item.hasClickListener) {
        item.addEventListener('click', toggleSubmenu);
        item.hasClickListener = true;  
      }
    });
  } else {
    submenuLinks.forEach(item => {
      if (item.hasClickListener) {
        item.removeEventListener('click', toggleSubmenu);
        item.hasClickListener = false; 
      }
    });
  }
}

function toggleSubmenu(e) {
  e.preventDefault();
  this.closest('.is-dd').classList.toggle('is-open');
}
 
handleSubmenuToggle();
window.addEventListener('resize', handleSubmenuToggle);
 

const promocodeLink = document.querySelector('.js-promocode-show');
if(promocodeLink){
	promocodeLink.addEventListener('click', (event) =>{
		document.querySelector('.promocode').classList.toggle('is-shown');
	})
}


// resize events
window.addEventListener("resize", () => {
	coreApp.initResize();
});

// ESC handler
document.addEventListener("keydown", (event) => {
	if (event.key === "Escape") {
		if (document.querySelector(".js-popup-show")) {
			popupApp.clear();
		}
		if (document.querySelector(".is-m-popup-show")) {
			mobilePopupApp.clear();
		}

		if (document.querySelector(".js-show-search")) {
			$body.classList.remove("js-show-search");
		}
	}
});

const moreVariantLinks = document.querySelectorAll('.js-variants-more');
if (moreVariantLinks.length > 0) {  
	moreVariantLinks.forEach(item => {
		 item.addEventListener('click', (e) => {
			  const closestVariants = e.currentTarget.closest('.variants__items');
			  if (closestVariants) {
					closestVariants.classList.add('is-shown');
			  }
		 });
	});
}


function initVideoFromSocial2() {
	const socialVideo = document.querySelector(".js-social-video");

	if (socialVideo) {
		socialVideo.classList.remove("preview");
	}

	const slider = new Swiper(".js-social-video .swiper", {
		speed: 300, 
		spaceBetween: 40, 
		slidesPerView: 'auto',
		navigation: {
			nextEl: ".js-button-next",
			prevEl: ".js-button-prev",
		},
		breakpoints: {
			0: { slidesPerView: "auto"}, 
			992: {spaceBetween: 20}  
		},
		on: {
			slideChange: function () {
				const slides = this.slides;
				let slidesIndex = this.realIndex;
				slidesIndex++;
				slides.forEach((slide, i) => {
					const video = slide.querySelector("video");
					// const frame = slide.querySelector('iframe');
					// const btn = slide.querySelector('.videobtn');
					// let src1, src2, src3;

					if (i === this.activeIndex) {
						video.play();
					} else {
						video.pause();
					}

					/*
			  if (frame) {
				 src1 = frame.getAttribute('data-src');
				 src2 = frame.getAttribute('data-src2');
				 src3 = frame.getAttribute('data-src3');
			  }

			  if (i === this.activeIndex) {
				 if (video) {
					video.play();
				 }
 
				 if (btn) {
					if (btn.classList.contains('active')) {
					  frame.src = frame ? src1 : null;
					} else {
					  frame.src = frame ? src3 : null;
					}
				 } else {
					frame.src = frame ? src3 : null;
				 }
			  } else {
				 if (video) {
					video.pause();
				 }
 
				 frame.src = frame ? src2 : null;
			  }
				 */
				});
			},
		},
	});

	document.querySelectorAll(".js-social-video .swiper-slide").forEach((el) => {
		const btn = el.querySelector(".r_videoThumb__mute");
		//const frame = el.querySelector('iframe');
		let src;

		/*
	  if (frame) {
		 src = frame.getAttribute('data-src');
	  }
 */
		const video = el.querySelector("video");

		if (btn) {
			btn.addEventListener("click", () => {
				btn.classList.toggle("is-unmute");
				if (btn.classList.contains("is-unmute")) {
					// frame.src = frame ? src : null;
					if (video) {
						video.muted = false;
						video.setAttribute("mute", "false");
					}
				} else {
					/*
			  if (frame) {
				 frame.src += '&mute=1';
			  }
				 */
					if (video) {
						video.muted = true;
						video.setAttribute("mute", "true");
					}
				}
			});
		}
	});
}

document.addEventListener("DOMContentLoaded", initVideoFromSocial2);


const demoCalculator = document.querySelector('.r_calculator');
if(demoCalculator){
	const btn = demoCalculator.querySelector('.js-submit-calculator');
	const form = demoCalculator.querySelector('.js-calculator-form');
	if(btn){
		btn.addEventListener('click', function(){
			demoCalculator.classList.add('is-show-results');
		}) 
	}
 
	form.addEventListener('submit', (e) => {
		e.preventDefault();
		if (coreApp.getFormValidation(form)) {
			 return;
		} 
 
		const inputUnderBust = form.querySelector('.js-input-underBust');
      const inputBust = form.querySelector('.js-input-bust');
		const underBustValue = Number(inputUnderBust.value);
      const bustValue = Number(inputBust.value);
		const errorResult = form.querySelector('.js-form-error');
		let hasError = false;
 
		if (isNaN(underBustValue) || underBustValue <= 0) {
			inputUnderBust.closest('.form__group').classList.remove('is-success');
			inputUnderBust.closest('.form__group').classList.add('is-error');
			hasError = true;
		 }
	  
		 
		 if (isNaN(bustValue) || bustValue <= 0) {
			inputBust.closest('.form__group').classList.remove('is-success');
			inputBust.closest('.form__group').classList.add('is-error');
			hasError = true;
		 }

		 errorResult.textContent = '';

		 if (hasError) { 
			return;
		 }
		 coreApp.loader();
 
		const bandSizes = [65, 70, 75, 80, 85, 90, 95, 100];
		const bandSize = bandSizes.find(size => size >= underBustValue);

		if (!bandSize) {
			errorResult.textContent = 'Размер под грудью вне допустимого диапазон';
			return;
		}
 
		const difference = bustValue - underBustValue;
		const cupSizes = ['AA', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
		const cupIndex = Math.floor((difference - 10) / 2); 
		const cupSize = cupSizes[cupIndex] || ' (N/A)'; 
		document.querySelector('.js-calculator-results').textContent = `${bandSize}${cupSize}`;
		demoCalculator.classList.add('is-show-results');
		coreApp.loader('hide');

		 
	});

}

const citySelector = document.querySelector('.js-contacts-change-city');
if(citySelector){
	citySelector.addEventListener('change', function (e) {
		const selectedCity = e.target.value; // Читаем значение выбранного города
		const sections = document.querySelectorAll('.js-contacts-section'); // Находим все блоки
	 
		sections.forEach(section => {
		  if (section.dataset.city === selectedCity) {
			 section.classList.remove('none'); // Удаляем класс .none у совпадающего блока
		  } else {
			 section.classList.add('none'); // Добавляем класс .none у остальных блоков
		  }
		});
	 });
}



 const feedbackForms = document.querySelectorAll('.js-feedback-form')

 if(feedbackForms.length){
	feedbackForms.forEach(form => {
		form.addEventListener('submit', (e) => {
			e.preventDefault();
			if (coreApp.getFormValidation(form)) {
				 return;
			} 
		})
	})
	 
 }


 // menu app
const menuApp = function () {  
	return {
		init: function () { 
			const menuLink = document.querySelector('.js-toggle-mobile-nav');
			if(menuLink){
				menuLink.addEventListener('click', (e) => {
					e.preventDefault();     
					if($body.classList.contains('js-show-mainmenu')){ 
						$body.classList.remove('js-show-mainmenu'); 
					}else{ 
						$body.classList.add('js-show-mainmenu'); 
					}
				}); 
			} 
			menuApp.default();
		}, 
		reset: function(){
			$body.classList.remove('js-show-mainmenu', 'is-menu-show-1', 'is-menu-show-2');
			document.querySelectorAll('.js-mainmenu .is-open').forEach(item => {
				item.classList.remove('is-open');
			})
		},  
		hoverIntent: function(){
			let uiCatalogDropdowns = document.querySelectorAll('.js-mainmenu .nav__item.is-dd');

			if(coreApp.isTouchDevice() == false && coreApp.getViewPort().width > 1199){
				let timer;
				let delay = 160; 
				if(uiCatalogDropdowns.length){ 
					uiCatalogDropdowns.forEach(item => { 
						item.addEventListener('mouseenter', () => { 
							timer = setTimeout(function(){
								$body.classList.add('js-menu-hover');
								item.classList.add('is-hover');
							}, delay);
						})

						item.addEventListener('mouseleave', () => { 
							clearTimeout(timer);
							$body.classList.remove('js-menu-hover');
							item.classList.remove('is-hover');
						}) 
					})
				}
			} 
		},
		default: function(){
			 
			menuApp.reset();
			
			 
			if(coreApp.isTouchDevice() == false && coreApp.getViewPort().width > 1199){
				menuApp.hoverIntent(); 
			}

			const mainMenuLinks = document.querySelectorAll('.js-mainmenu .nav__item.is-dd'); 

	 
			if(coreApp.isTouchDevice() == true || coreApp.getViewPort().width < 1200){ 
				mainMenuLinks.forEach(function(item){ 
					item.querySelector('.nav__item_link').addEventListener('click', menuHandlerLevelOne);		 
				}); 
			}

			 
		}  
	};
}(); 

function menuHandlerLevelOne(e) { 
	e.preventDefault();  
	let item = e.target.parentElement;  
	let elements = [...document.querySelectorAll('.js-mainmenu .nav__item.is-dd ')];
	let otherElements = elements.filter(function(element) {
	return element !== item;
	}); 

	if(otherElements.length){
		otherElements.forEach(function(other, i){
			other.classList.remove('is-open');
			other.querySelectorAll('.nav__item.is-open').forEach(function(opened, i){
				opened.classList.remove('is-open');
			})
		})
	}
	if(coreApp.getViewPort().width > 1199){
		$body.classList.add('js-menu-hover'); 
	} 
	item.classList.add('is-open'); 
	$body.classList.add('is-menu-show-1'); 
}


menuApp.init()
 

document.querySelectorAll('.hs-header-layout span').forEach(el => {
  el.textContent = el.textContent.replace(/^\s*•\s*/, '');
});
 
const langBtn = document.querySelector('.disclosure__button')
langBtn.addEventListener('click', function(){
	const langWrapper = document.querySelector('.lang')
	langWrapper.classList.toggle('open');
})


const footerBoxes = document.querySelectorAll('.footerBox--hide');
if(footerBoxes.length){
	footerBoxes.forEach(footerBox => {
		const title = footerBox.querySelector('.footerBox__title'); 
		title.addEventListener('click', function() {
		  footerBox.classList.toggle('is-open');
		});
	 });
}

const mobileMenu = document.querySelectorAll('.nav--mobilenav .nav__item.is-dd ');
if(mobileMenu.length){
	mobileMenu.forEach(item => {
		const title = item.querySelector('.nav__item_toggle'); 
		title.addEventListener('click', function() {
		  item.classList.toggle('is-open');
		});
	 });
}

const textBanner = document.querySelectorAll('.r_textMedia .js-textbanner-toggle');
if(textBanner.length){
	textBanner.forEach(item => {
	 
		item.addEventListener('click', function() {
		  item.closest('.r_textMedia').classList.toggle('is-open');
		});
	 });
} 
 
const ScrollMenu = {
  init() {
    if (window.innerWidth < 1200) return;

    this.productContainer = document.querySelector('.r_product');
    if (!this.productContainer) return;

    this.submenuSections = document.querySelectorAll('.section[data-submenu]');
    if (this.submenuSections.length === 0) return;

    this.linksContainer = document.createElement('div');
    this.linksContainer.classList.add('r_product__links');
    this.linkMap = new Map();

    this.createLinks();
    this.productContainer.prepend(this.linksContainer);
    this.productHeight = this.productContainer.offsetHeight;

    this.bindEvents();
    this.onScroll();
  },

  createLinks() {
    this.submenuSections.forEach(section => {
      const scrollValue = section.dataset.submenu;
      const titleElement = section.querySelector('.section__header_title');
      const titleText = titleElement ? titleElement.textContent.trim() : '';

      const linkItem = document.createElement('div');
      linkItem.classList.add('item');
      linkItem.setAttribute('data-scroll', scrollValue);
      linkItem.textContent = titleText;

      this.linkMap.set(scrollValue, linkItem);
      this.linksContainer.appendChild(linkItem);
    });
  },

  bindEvents() {
    window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    window.addEventListener('resize', this.onScroll.bind(this));
    window.addEventListener('load', this.onScroll.bind(this));

    this.linksContainer.addEventListener('click', this.onLinkClick.bind(this));
  },

  onLinkClick(event) {
    const target = event.target;
    if (!target.classList.contains('item')) return;

    const scrollValue = target.getAttribute('data-scroll');
    const section = Array.from(this.submenuSections).find(s => s.dataset.submenu === scrollValue);
    if (!section) return;

    const rect = section.getBoundingClientRect();
    const offset = window.innerHeight * 0.19;
    const targetScrollY = window.scrollY + rect.top - offset;

    window.scrollTo({
      top: targetScrollY,
      behavior: 'smooth'
    });
  },

  onScroll() {
    if (window.innerWidth < 1200) {
      this.linksContainer.classList.remove('is-fixed');
      this.linkMap.forEach(link => link.classList.remove('is-selected'));
      return;
    }

    const offset = window.innerHeight * 0.2;
    const scrollY = window.scrollY + offset;

    if (window.scrollY >= this.productHeight) {
      this.linksContainer.classList.add('is-fixed');
    } else {
      this.linksContainer.classList.remove('is-fixed');
    }

    let found = false;

    this.submenuSections.forEach(section => {
      const scrollValue = section.dataset.submenu;
      const rect = section.getBoundingClientRect();
      const top = window.scrollY + rect.top;
      const bottom = top + rect.height;

      const link = this.linkMap.get(scrollValue);

      if (scrollY >= top && scrollY < bottom) {
        link.classList.add('is-selected');
        found = true;
      } else {
        link.classList.remove('is-selected');
      }
    });

    if (!found) {
      this.linkMap.forEach(link => link.classList.remove('is-selected'));
    }
  }
};
document.addEventListener('DOMContentLoaded', () => ScrollMenu.init());


/*! HSCart tweaks */ 
window.HS_SLIDE_CART_UPDATED = function(cart) {
	const cartTitleSelector = document.querySelector('.hs-header-title');
	if (cartTitleSelector && !cartTitleSelector.querySelector('.r_count')) {
	const cartCount = document.createElement('span');
	cartCount.classList.add('r_count');
	cartCount.textContent = cart.item_count;
	cartTitleSelector.appendChild(cartCount);
	}else{
		cartTitleSelector.querySelector('.r_count').textContent = cart.item_count
	}
	const paymentsSelector = document.querySelector('.hs-trust-payment');
	if (paymentsSelector && !paymentsSelector.querySelector('.r_payment-title')) {
		const paymentsEl = document.createElement('span');
		paymentsEl.classList.add('r_payment-title');
		paymentsEl.textContent = window.cartStrings.payment;
		paymentsSelector.appendChild(paymentsEl);
	}
	const cartTextSelector = document.querySelector('.hs-content-total-cart');
	if (cartTextSelector && !cartTextSelector.querySelector('.r_cart-text')) {
		const cartTextEl = document.createElement('span');
		cartTextEl.classList.add('r_cart-text');
		cartTextEl.textContent = window.cartStrings.discounts_text;
		cartTextSelector.appendChild(cartTextEl);
	}
}

 document.querySelectorAll('.r_promo__dot_point').forEach(dotPoint => {
  dotPoint.addEventListener('click', function () {
    const parentDot = this.closest('.r_promo__dot');
    if (parentDot) {
      parentDot.classList.toggle('is-open');
    }
  });
});